module.exports = __webpack_public_path__ + "b812b838ad66c297698d67e2e68d304a.fbx";